export const INTEREST_TYPE_OPTIONS = [
  { value: "fixed", label: "Stałe" },
  { value: "variable", label: "Zmienne" },
  { value: "periodically_fixed", label: "Okresowo-stałe" },
];

export const DURATION_OPTIONS = [
  { value: "indefinite", label: "Bezterminowo" },
  { value: "specific_date", label: "Dokładna data zakończenia" },
];

export const PREMIUM_PAYMENT_OPTIONS = [
  { value: "monthly", label: "Miesięczne" },
  { value: "quarterly", label: "Kwartalne" },
  { value: "yearly", label: "Roczne" },
  { value: "at_end_of_year", label: "Na koniec roku" },
];

export const INTEREST_PAYMENT_OPTIONS = [
  { value: "monthly", label: "Miesięczne" },
  { value: "quarterly", label: "Kwartalne" },
  { value: "yearly", label: "Roczne" },
  { value: "at_end", label: "Na koniec roku" },
];

export const AUTO_RENEWAL_OPTIONS = [
  { value: "true", label: "Tak" },
  { value: "false", label: "Nie" },
];

export const LOAN_TYPE_OPTIONS = [
  { value: "borrowed", label: "Zaciągnięta" },
  { value: "lent", label: "Udzielona" },
];

export const PROPERTY_TYPE_OPTIONS = [
  { value: "apartment", label: "Mieszkanie" },
  { value: "house", label: "Dom" },
  { value: "land", label: "Działka" },
  { value: "other", label: "Inne" },
];

export const STATUS_OPTIONS = [
  { value: "active", label: "Aktywne" },
  { value: "withdrawn", label: "Wycofane" },
  { value: "hidden", label: "Ukryte" },
];

export const RELIANCE_CONSENT_LABEL =
  "Udzielam zgody, by pracownicy firmy Reliance mieli dostęp do szczegółów związanych z tym aktywem.";

export const RELIANCE_CONSENT_TRANSACTIONS_LABEL =
  "Udzielam zgody, by pracownicy firmy Reliance mieli dostęp do historii moich transakcji związanych z tym aktywem.";
